const oyRunShareUrl = {
    shareIcons: [
        {
            text: "카카오톡",
            img: "common/icon_sns_kakao.png",
            type: "kakaotalk",
        },
        {
            text: "블로그",
            img: "common/icon_sns_blog.png",
            type: "naverblog",
        },
        {
            text: "페이스북",
            img: "common/icon_sns_fb.png",
            type: "facebook",
        },
        {
            text: "라인",
            img: "common/icon_sns_line.png",
            type: "naverline",
        },
        {
            text: "트위터",
            img: "common/icon_sns_x.png",
            type: "twitter",
        },
        {
            text: "URL",
            img: "common/icon_sns_url.png",
            type: "copyURL",
        },
    ],
    _appShareUrl: null,
    _createShortenUrl: function(originalUrl) {

        return new Promise(function (resolve) {

            if (originalUrl.includes('oy.run')) {
                resolve(originalUrl);
                return;
            }
            const currentDate = new Date();
            const yy = currentDate.getFullYear().toString().substr(-2).padStart(2, "0");
            const MM = (currentDate.getMonth() + 1).toString().padStart(2, "0");
            const dd = currentDate.getDate().toString().padStart(2, "0");
            const HH = currentDate.getHours().toString().padStart(2, "0");
            const mm = currentDate.getMinutes().toString().padStart(2, "0");
            const formattedDate = yy + MM + dd + HH + mm;
            const rawData = _shortenUrlApiKey +  ':shrt-auth:' + formattedDate;
            const encodedDate = btoa(rawData);
            const data = {
                originalUrl: originalUrl
            };
            const xhr = new XMLHttpRequest();
            xhr.open('POST',  "/base/shorten/verified", true);
            xhr.setRequestHeader("x-api-key", encodedDate);
            xhr.setRequestHeader('Content-type', 'application/json');
            xhr.setRequestHeader("accept", "application/json");
            xhr.onload = function() {
                let shortenUrl = originalUrl;
                try {
                    if (xhr.status === 200 && xhr.responseText) {
                        const data = JSON.parse(xhr.responseText);
                        shortenUrl = data.shortenedUrl ? data.shortenedUrl : originalUrl;
                    }
                } finally {
                    resolve(shortenUrl);
                }
            };
            xhr.onerror = function () {
                resolve(originalUrl)
            };
            xhr.send(JSON.stringify(data));
        });

    },
    _eventTracking: function(obj, clickType) {
        const dataAttrs = $(obj).data();

        if (dataAttrs.amplitudename && dataAttrs.entrysource) {
            const eventProperties = {};

            eventProperties.entry_source = dataAttrs.entrysource;

            if (dataAttrs.clicksource) {
                eventProperties.click_source = dataAttrs.clicksource + (clickType ? clickType : "");
            }

            if (dataAttrs.dispcatno) {
                eventProperties.dispCatNo = dataAttrs.dispcatno;
            }

            if (dataAttrs.planname) {
                eventProperties.plan_name = dataAttrs.planname;
            }

            if (dataAttrs.eventname) {
                eventProperties.event_name = dataAttrs.eventname;
            }

            if (dataAttrs.yeartype) {
                eventProperties.year_type = dataAttrs.yeartype;
            }

            if (typeof common.reqAmplitude !== "undefined") {
                common.reqAmplitude(dataAttrs.amplitudename, eventProperties)
            }
        }
    },
    _open: function (dataAttrs) {
        let shareModal = $("#snsSharePopupBottomUp");

        if (shareModal.length === 0) {
            const header = '<div class="header"><div class="title">공유하기</div><button type="button" class="button"><span class="blind">닫기</span></button></div>';
            let list = '';
            oyRunShareUrl.shareIcons.forEach(function (item) {
                list += '<li><a href="javascript:;" title="' + item.text + ' 이동" data-type="' + item.type + '" class="snsShare" name="aSnsShare"><img src="' + _imgUrl + item.img + '" alt="' + item.text + '" /></a></li>';
            });

            const snsSharePopupBottomUp = document.createElement("div");
            snsSharePopupBottomUp.id = "snsSharePopupBottomUp"
            snsSharePopupBottomUp.innerHTML = '<div class="inner">' + header + '<ul class="list">' + list + '</ul></div>';

            const snsShareToastPopup = document.createElement("div");
            snsShareToastPopup.id = "snsShareToastPopup"
            snsShareToastPopup.innerHTML = '<p class="inner">URL이 복사가 되었습니다.</p>';
            document.body.append(snsSharePopupBottomUp);
            document.body.append(snsShareToastPopup);

            const aTags = $('#snsSharePopupBottomUp').find('a[name=aSnsShare]');

            aTags.on("click", function(e) {
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                oyRunShareUrl._share(this, this.dataset.type);

            });

            if (dataAttrs) {
                for (const [key, value] of Object.entries(dataAttrs)) {
                    aTags.data(key, value);
                }
            }

            $('#snsSharePopupBottomUp').find('button').on("click", function() {
                oyRunShareUrl.close();
            });

            $('#snsSharePopupBottomUp').on("click", function() {
                oyRunShareUrl.close();
            });

            shareModal = $("#snsSharePopupBottomUp");
        }

        $("body").css("overflow", "hidden");
        shareModal.removeClass("leave").addClass("enter");
    },
    _openLink: function(type) {
        if (type === "kakaotalk") {
            Kakao.Link.cleanup();
            Kakao.Link.sendDefault({
                objectType : 'feed',
                content : {
                    title : common.sns.title,
                    imageUrl : common.sns.imgUrl,
                    link : {
                        webUrl : common.sns.shareUrl,
                        mobileWebUrl : common.sns.shareUrl,
                        androidExecParams : common.sns.shareUrl,
                        iosExecParams : common.sns.shareUrl
                    }
                },
                buttons : [ {
                    title : '앱으로 보기',
                    link : {
                        mobileWebUrl : oyRunShareUrl._appShareUrl || common.sns.shareUrl,
                        webUrl : oyRunShareUrl._appShareUrl || common.sns.shareUrl
                    }
                } ],
                installTalk : true
            });

        } else if (type === "facebook") {
            const facebookShareUrl = common.sns.shareUrl.replaceAll(encodeURIComponent("&"), "&");
            window.open("http://m.facebook.com/sharer.php?u=" + encodeURIComponent(facebookShareUrl));

        } else if (type === "naverblog") {
            const naverBlogShareUrl = common.sns.shareUrl.replaceAll("\\+", encodeURIComponent("+"));
            window.open("http://share.naver.com/web/shareView?url=" + encodeURIComponent(naverBlogShareUrl) + "&title=" + encodeURIComponent(common.sns.title));

        } else if (type === "naverline") {
            window.open("https://line.me/R/msg/text/?" + encodeURIComponent(common.sns.title + '\r\n' + common.sns.shareUrl));
        } else if (type === "twitter") { // 트위터
            window.open("https://twitter.com/intent/tweet?url=" + encodeURIComponent(common.sns.shareUrl) + "&text=" + encodeURIComponent(common.sns.title));
        }
    },
    _share: function (obj, snsType) {
        if (!Kakao.isInitialized()) {
            Kakao.init('24077b12ac18b11a96696382ccaa7138');
            common.sns.imgUrl = document.querySelector('meta[property="og:image"]').content;
            common.sns.title = document.querySelector('meta[property="og:title"]').content;
            common.sns.shareUrl = document.querySelector('meta[property="og:url"]').content;
        }

        const findShare = oyRunShareUrl.shareIcons.find(function (item) {
            return item.type === snsType
        });

        if (!findShare) {
            return;
        }

        oyRunShareUrl._eventTracking(obj, findShare.text);

        if (snsType === "copyURL") {
            const createTextarea = document.createElement('textarea');
            createTextarea.value = document.querySelector('meta[property="og:url"]').content;

            document.body.appendChild(createTextarea);

            createTextarea.readOnly = true;
            createTextarea.select();
            createTextarea.setSelectionRange(0, 9999);
            document.execCommand('copy');

            document.body.removeChild(createTextarea);

            oyRunShareUrl.close();

            const isAndroid = /(android)/i.test(window.navigator.userAgent);
            if(!isAndroid) {
                const $toastPopupEl = $('#snsShareToastPopup');
                $toastPopupEl.addClass('open').removeClass('close');
                setTimeout(function(){
                    $toastPopupEl.removeClass('open').addClass('close');
                }, 2000);
            }
        } else {
            try {
                oyRunShareUrl._openLink(snsType);
            } catch (err) {
                void 0;
            }
        }
    },
    close: function () {
        $("body").css("overflow", "visible");
        if (typeof mayflyQueen !== "undefined" && mayflyQueen.disablePageSelect) {
            mayflyQueen.disablePageSelect();
        }

        $("#snsSharePopupBottomUp").removeClass("enter").addClass("leave");
    },
    share: function (appShareUrl, dataAttrs) {

        const _shareTitle = document.querySelector('meta[property="og:title"]').content;
        const _shareUrl = document.querySelector('meta[property="og:url"]').content;
        oyRunShareUrl._appShareUrl = appShareUrl;
        oyRunShareUrl._createShortenUrl(_shareUrl).then(function (shortenUrl) {
            document.querySelector('meta[property="og:url"]').content = shortenUrl;

            if (typeof mayflyQueen !== "undefined" && mayflyQueen.enablePageSelect) {
                mayflyQueen.enablePageSelect();
            }

            if (common.app.appInfo.isapp && common.app.sendAppSnsShareEvent(_shareTitle, shortenUrl)) {
                return;
            }

            oyRunShareUrl._open(dataAttrs);
        });
    },
}

if (!common.app.appInfo.isapp) {
    if (typeof Kakao === "undefined") {
        const script = document.createElement("script");
        script.src = "https://developers.kakao.com/sdk/js/kakao.min.js";
        script.defer = true;
        document.head.appendChild(script);
    }
}